import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class OktaRouteGuard implements CanActivate {
    constructor(private authService: AuthService, private router: Router) {}

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        const isAuthenticated = await this.authService.isAuthenticated();

        if (!isAuthenticated) {
            this.router.navigate(['/not-authenticated']);
            return false;
        }

        await this.authService.loadPermissionsIntoLocalStorage();

        const requiredAreas: string[] = route.data['areas'] || [];
        const requiredPermissions: string[] = route.data['permissions'] || [];

        const hasAccess = this.authService.hasPermissions(requiredAreas, requiredPermissions);

        if (!hasAccess) {
            this.router.navigate(['/not-authorized']);
        }

        return hasAccess;
    }
}